module.exports = __webpack_public_path__ + "img/homesecurity_7.svg";